var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.39,141.53h98.93c64.71,0,112.72,24.45,143.81,73.21,31.16,48.9,46.74,101.98,46.74,159.39,0,102.58-30.57,172.21-91.62,208.89l223.58,337.12-65.98,18.34-221.71-333.39c-7.31,1.19-18.94,1.79-34.81,1.79h-29.3v320.57h-69.63V141.53ZM401.67,211.16v327.87h25.65c33.03,0,58-7.9,75.15-23.86,30.49-25.65,45.77-72.61,45.77-141.05,0-36.53-13.42-73.21-40.33-109.89-25.65-35.49-52.48-53.08-80.59-53.08h-25.65ZM751.61,625.21l-207.03,313.26-64.11-20.13,217.98-337.12,53.15,43.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRx);
export default __webpack_public_path__ + "static/media/Rx.2e0c7b4d9305c4ea6a91da78d20d1ff0.svg";
export { ForwardRef as ReactComponent };